import React from 'react';
import type { FC } from 'react';

interface EnvelopeIconProps {
    className?: string;
}

export const EnvelopeIcon: FC<EnvelopeIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="29"
            height="30"
            viewBox="0 0 29 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Envelope Icon</title>
            <g clipPath="url(#clip0_4836_20088)">
                <path
                    d="M24.2849 23.5748V12.8795C24.2849 12.418 24.062 11.985 23.6866 11.7168L15.1136 5.59321C14.6168 5.23835 13.9494 5.23835 13.4526 5.59321L4.87959 11.7168C4.5041 11.985 4.28125 12.418 4.28125 12.8795V23.5748C4.28125 24.3639 4.92096 25.0036 5.71008 25.0036H22.8561C23.6452 25.0036 24.2849 24.3639 24.2849 23.5748Z"
                    stroke="white"
                    strokeWidth="1.42883"
                />
                <path
                    d="M24.2849 12.1445L14.8459 16.1898C14.4865 16.3438 14.0797 16.3438 13.7202 16.1898L4.28125 12.1445"
                    stroke="white"
                    strokeWidth="1.42883"
                />
            </g>
            <defs>
                <clipPath id="clip0_4836_20088">
                    <rect width="28.5766" height="28.5766" fill="white" transform="translate(0 0.710938)" />
                </clipPath>
            </defs>
        </svg>
    );
};
